import { Injectable } from '@angular/core';
import { pathsSaldo } from 'environments/paths-saldo';

@Injectable({ providedIn: 'root' })
export class OAuthRouteClassifierService {
    private readonly TOKEN_ENDPOINT_PATH: string = pathsSaldo.AUTH_PATH + 'token';

    public isTokenEndpoint(url: string): boolean {
        return url.includes(this.TOKEN_ENDPOINT_PATH);
    }

    public requiresTokenRefresh(url: string): boolean {
        if (this.isTokenEndpoint(url)) return false;

        return url.includes('/v3/users/') || url.includes(pathsSaldo.SOCKET_AUTH_PATH);
    }
}
